var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group form-group--number", class: _vm.getClass() },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { class: `col-sm-${_vm.component.size}` },
          [
            _c("label", [
              _vm._v(_vm._s(_vm.component.label) + "\n        "),
              _vm.isRequired()
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
            ]),
            _vm.component.suffix || _vm.component.prefix
              ? _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _vm.component.prefix
                      ? _c("span", { staticClass: "input-group-addon" }, [
                          _vm._v(_vm._s(_vm.component.prefix)),
                        ])
                      : _vm._e(),
                    _c(
                      "money",
                      _vm._b(
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.setRules(),
                              expression: "setRules()",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: _vm.component.key,
                            name: _vm.component.key,
                            disabled:
                              _vm.disabledHandler() && !_vm.isRequired(),
                            readonly: _vm.disabledHandler(),
                            placeholder: _vm.component.placeholder,
                            "data-vv-name": _vm.component.key,
                          },
                          nativeOn: {
                            focus: function ($event) {
                              return _vm.focusHandler()
                            },
                            blur: function ($event) {
                              return _vm.blurHandler()
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                $event.keyCode !== 13
                              )
                                return null
                              return _vm.enterHandler()
                            },
                          },
                          model: {
                            value: _vm.component.data.currentValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.component.data, "currentValue", $$v)
                            },
                            expression: "component.data.currentValue",
                          },
                        },
                        "money",
                        _vm.format,
                        false
                      )
                    ),
                    _vm.component.suffix
                      ? _c("span", { staticClass: "input-group-addon" }, [
                          _vm._v(_vm._s(_vm.component.suffix)),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _c(
                  "money",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.setRules(),
                          expression: "setRules()",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: _vm.component.key,
                        disabled: _vm.disabledHandler() && !_vm.isRequired(),
                        readonly: _vm.disabledHandler(),
                        placeholder: _vm.component.placeholder,
                        "data-vv-name": _vm.component.key,
                      },
                      nativeOn: {
                        focus: function ($event) {
                          return _vm.focusHandler()
                        },
                        blur: function ($event) {
                          return _vm.blurHandler()
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            $event.keyCode !== 13
                          )
                            return null
                          return _vm.enterHandler()
                        },
                      },
                      model: {
                        value: _vm.component.data.currentValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.component.data, "currentValue", $$v)
                        },
                        expression: "component.data.currentValue",
                      },
                    },
                    "money",
                    _vm.format,
                    false
                  )
                ),
            _vm.errors.has(_vm.component.key)
              ? _c("span", { staticClass: "help-block help-block--bottom" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 14 14",
                        width: "14",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "form_icon_error_alert",
                            transform: "translate(-252 -635)",
                          },
                        },
                        [
                          _c("rect", {
                            staticClass: "cls-1",
                            attrs: {
                              id: "rectangle",
                              width: "14",
                              height: "14",
                              transform: "translate(252 635)",
                            },
                          }),
                          _c("path", {
                            staticClass: "cls-2",
                            attrs: {
                              id: "ic_error_outline_24px",
                              d: "M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z",
                              transform: "translate(251 634)",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v("\n        " + _vm._s(_vm.errorText()) + "\n      "),
                ])
              : _vm._e(),
            !_vm.errors.has(_vm.component.key) && _vm.component.description
              ? _c("span", { staticClass: "help-block help-block--bottom" }, [
                  _vm._v(_vm._s(_vm.component.description)),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }